import React from 'react';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import Type from 'components/Type';

import classes from './Card.module.scss';

interface ISubCategories {
  key: number;
  title: string;
  onClick: () => void;
}

interface IProps {
  title: string;
  description: string;
  image: string;
  subCategories: ISubCategories[];
  gradient: {
    start: string;
    end: string;
  };
  className?: string;
  soon?: boolean;
  onClick?: () => void;
}

const Info: React.FC<IProps> = ({ title, image, description, subCategories, gradient, className, soon, onClick }) => {
  const { t } = useTranslation();

  return (
    <div
      className={cx(classes.wrapper, classes.wrapperInfo, className)}
      style={{ '--gradient-start': `${gradient.start}`, '--gradient-end': `${gradient.end}` } as React.CSSProperties}
      onClick={(e: React.SyntheticEvent) => {
        const target = e.target as HTMLDivElement;
        if (!target.classList.contains('subCategory')) {
          onClick && onClick();
        }
      }}
    >
      <div className={classes.image}>
        <img src={image} />
      </div>
      <div className={classes.content}>
        {!!soon && (
          <div className={classes.soon}>
            <Type variant="blue">{t('Quickly')}</Type>
          </div>
        )}
        <div className={classes.title} {...(window.matchMedia('(min-width: 1200px)').matches && { ...{ onClick } })}>
          {title}
        </div>
        <div className={classes.description}>
          {window.matchMedia('(min-width: 1200px)').matches && subCategories.length !== 0 ? (
            <>
              {subCategories.map(subCategory => (
                <div key={subCategory.key} className={classes.subCategory} onClick={subCategory.onClick}>
                  {subCategory.title}
                </div>
              ))}
            </>
          ) : (
            <>{description}</>
          )}
        </div>
      </div>
    </div>
  );
};

export default Info;
